import { useEffect } from 'react';
import './styles/global.css';

import Navbar           from './components/Navbar';
import Footer           from './components/Footer';
import FloatingActions  from './components/FloatingActions';
import Hero         from './components/sections/Hero';
import Missao       from './components/sections/Missao';
import NossaLinha   from './components/sections/NossaLinha';
import ImpactoReal  from './components/sections/ImpactoReal';
import ComoFunciona from './components/sections/ComoFunciona';
import Galeria      from './components/sections/Galeria';
import Produtos     from './components/sections/Produtos';
import CtaFinal     from './components/sections/CtaFinal';

export default function App() {
  useEffect(() => {
    const targets = document.querySelectorAll('.reveal, .reveal--left, .reveal--right');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target); // anima só uma vez
          }
        });
      },
      { threshold: 0.12 }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Navbar />

      <main>
        <Hero />
        <div className="reveal"><Missao /></div>
        <div className="reveal"><NossaLinha /></div>
        <div className="reveal"><ImpactoReal /></div>
        <div className="reveal"><ComoFunciona /></div>
        <div className="reveal"><Galeria /></div>
        <div className="reveal"><Produtos /></div>
        <div className="reveal"><CtaFinal /></div>
      </main>

      <Footer />
      <FloatingActions />
    </>
  );
}
